import DotsLoading from 'common-components/DotsLoading'

import { COLORS } from 'consts/colors'

import * as Styled from './styled'

export const UploadMusicLoading: React.FC<{
  name: string
}> = ({ name }) => {
  return (
    <Styled.UploadMusicLoadingWrapper>
      <Styled.UploadSoundLoadingText
        type="h4"
        color="secondarySemiDark"
        ellipsis
      >
        {name}
      </Styled.UploadSoundLoadingText>

      <Styled.DotsLoadingWrapper>
        <DotsLoading dotColor={COLORS.primaryDark} size="xSmall" />
      </Styled.DotsLoadingWrapper>
    </Styled.UploadMusicLoadingWrapper>
  )
}
